import { Event, EventAttendanceStatus } from 'src/app/models/event';

export enum AttendanceUserRole {
  ATTENDEE = 'Attendee',
  ORGANIZER = 'Organizer',
}

export class AttendanceUser {
  _id: string;
  role: AttendanceUserRole | string;
  name: string;
  email: string;
  profile_image?: string;
  join_time?: Date;
  notes?: string;
  status?: EventAttendanceStatus;
  auto_added?: boolean;
  inInstitution?: boolean;
  constructor(res: AttendanceUser) {
    this._id = res._id;
    this.role = res.role as AttendanceUserRole;
    this.email = res.email;
    this.name = res.name ?? res.email;
    this.profile_image = res.profile_image;
    this.join_time = res?.join_time ? new Date(res?.join_time) : undefined;
    this.notes = res?.notes ?? '';
    this.status = res?.status ?? EventAttendanceStatus.ABSENT;
    this.auto_added = res.auto_added ?? false;
    this.inInstitution = res.inInstitution ?? false;
  }
}

export class AttendanceEvent {
  _id: string;
  title: string;
  start_time: Date;
  end_time?: Date;
  recurrence?: string;
  startTimeOnClient: Date;
  constructor(res: EventWithTimingInfo) {
    this._id = res._id;
    this.title = res.title;
    this.start_time = new Date(res.start_time);
    this.end_time = new Date(res.end_time!);
    this.recurrence = res.recurrence?.text;
    this.startTimeOnClient = res.startTimeOnClient ?? this.start_time;
  }
}

export type EventWithTimingInfo = Event & {
  eventStartTimeOffsetMillis: number;
  eventEndtTimeOffsetMillis: number;
  startTimeOnClient: Date | undefined;
};
